import styled from 'styled-components'

const WarningContainer = styled.div`
  background-color: #ffe9ac;
  box-shadow: 4px 4px 29px rgba(19, 69, 186, 0.0855129);
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const WarningMessage = styled.p`
  color: #856404;
  margin: 0;
  font-size: 16px;
`

const WarningDetails = styled.p`
  color: #856404;
  margin-top: 8px;
  font-size: 14px;
`

const WarningButton = styled.button`
  background-color: #ffc107;
  width: 128px;
  height: 48px;
  border-radius: 10px;
  border: none;
  color: var(--color-text-on-primary);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export { WarningContainer, WarningMessage, WarningDetails, WarningButton }
